import React, { useState } from 'react'
import { TParentChild } from '../../../shared/types/parentChild.type'
import { GridCellParams, GridColDef, GridValueFormatterParams, GridValueGetterParams } from '@mui/x-data-grid';
import { t } from 'i18next';
import I18nDataGrid from '../../global/I18nDataGrid';
import dayjs from 'dayjs';

import utc from 'dayjs/plugin/utc'
import { useAuth } from '../../../hooks/useAuth';
import { Box, IconButton, Skeleton, Typography } from '@mui/material';
import { Delete } from '@mui/icons-material';
import { Icon } from '@iconify/react';
import { isEmpty, toNumber, upperCase } from 'lodash';
import DeleteModal from '../../modals/DeleteModal';


type ChildTableProps = {
    isLoading: boolean,
    isDeleting: boolean,
    data: TParentChild[],
    onDelete: (id: number) => void,
    open: boolean,
    handleClose: (value: boolean) => void,
    countChildren: number,
    page: number,
    onPageChange: (page: number) => void
}

function ChildTable({ data, isLoading, isDeleting, onDelete, open, handleClose, countChildren, page, onPageChange }: ChildTableProps) {

    const { getUserDateFormat } = useAuth()
    const [selectedId, setSelectedId] = useState<number | null>(null)

    const columns: GridColDef[] = [
        { field: 'parent.full_name', flex: 1, minWidth: 200, headerName: t('equimetre:table:name'), valueGetter: (params: GridValueGetterParams<TParentChild>) => params.row.child.full_name },
        { field: 'parent.email', flex: 1, minWidth: 200, headerName: t('equimetre:table:email'), valueGetter: (params: GridValueGetterParams<TParentChild>) => params.row.child.email },
        { field: 'horse.name', flex: 1, minWidth: 200, headerName: t('horse'), valueGetter: (params: GridValueGetterParams<TParentChild>) => upperCase(params.row.horse?.name) },
        {
            field: 'date_start', type: 'dateTime', flex: 1, minWidth: 200, headerName: t('riders:startDate'),
            valueGetter: (params: GridValueGetterParams<TParentChild>) => params.row.date_start,
            valueFormatter: (params) => params.value ? dayjs(params.value as string).format(getUserDateFormat) : '',

        },
        {
            field: 'date_end', type: 'dateTime', flex: 1, minWidth: 200, headerName: t('riders:endDate'),
            valueGetter: (params: GridValueGetterParams<TParentChild>) => params.row.date_end,
            valueFormatter: (params) => params.value ? dayjs(params.value as string).format(getUserDateFormat) : '',

        },
        {
            headerName: t('settings:actions'),
            field: '',
            flex: 1, minWidth: 200,
            align: 'center',
            renderCell: (params: GridCellParams<TParentChild>) =>
                <Box display={'flex'} gap={1} alignItems={'center'} flexWrap={'wrap'}>
                    <IconButton color='error' onClick={() => handleDelete(toNumber(params.id))}>
                        <Icon icon='material-symbols-light:delete-outline-sharp'></Icon>
                    </IconButton>
                </Box>
        }
    ];

    const handleDelete = (id: number) => {
        setSelectedId(id)
        handleClose(true)
    }

    return (
        <>
            <DeleteModal isDeleting={isDeleting} onDelete={() => selectedId && onDelete(selectedId)} title={'thirdPartyApi:revokeAccess'} subtitle={'thirdPartyApi:revokeAccessConfirmation'} open={open} handleClose={() => {
                setSelectedId(null)
                handleClose(false)
            }
            }></DeleteModal>


            {
              
                    isEmpty(data) ?
                        <Box display={'flex'} justifyContent={'center'}>
                            <Typography variant='subtitle2'>{t('thirdPartyApi:noAccessToOthersData')}</Typography>
                        </Box>
                        :
                        <I18nDataGrid
                            rows={data}
                            loading={isLoading}
                            columns={columns}
                            getRowId={row => row.id}
                            disableRowSelectionOnClick
                            paginationMode="server"
                            rowCount={countChildren}
                            paginationModel={{
                                page,
                                pageSize: 30,
                            }}
                            onPaginationModelChange={(newModel) => {
                                // detect only page change
                                if (newModel.page !== page) {
                                    onPageChange(newModel.page)
                                    
                                }
                            }}
                            initialState={{
                                sorting: {
                                    sortModel: [{ field: "creation_date", sort: "desc" }],
                                },

                            }}
                        />
            }
        </>
    )
}

export default ChildTable